import React, { useEffect, useLayoutEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import AOS from "aos";
import HomeFour from "./pages/HomeFour";
import BlogDetails from "./pages/BlogDetails";
import Contact from "./pages/Contact";
import Industries from "./pages/Industries";
import IndustryDetails from "./pages/IndustryDetails";
import ServiceDetails from "./pages/ServiceDetails";
import Services from "./pages/Services";
import Blogs from "./pages/Blogs";
import AboutUs from "./pages/AboutUs";
import Login from "./pages/Login";
import ProjectDetails from "./pages/ProjectDetails";
import Dashboard from "./pages/Admin/Dashboard";
import BlogList from "./pages/Admin/BlogList";
import BlogForm from "./pages/Admin/BlogForm";
import CaseStudiesList from "./pages/CaseStudies";
import CaseStudies from "./pages/Admin/CaseStudies";
import CaseStudyForm from "./pages/Admin/CaseStudyForm";
import ContactMessages from "./pages/Admin/ContactMessages";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { ToastProvider } from "./context/ToastContext";
import { ContentAvailabilityProvider } from "./utils/contentAvailability";

export default function App() {
  const location = useLocation();

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  // scroll to top of page after a page transition.
  useLayoutEffect(() => {
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <LanguageProvider>
      <ToastProvider>
        <AuthProvider>
          <ContentAvailabilityProvider>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<HomeFour />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/aboutus" element={<AboutUs />} />
              <Route path="/blog/:slug" element={<BlogDetails />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/industry/:slug" element={<IndustryDetails />} />
              <Route path="/services" element={<Services />} />
              <Route path="/service/:slug" element={<ServiceDetails />} />
              <Route path="/case-studies" element={<CaseStudiesList />} />

              {/* Auth Routes */}
              <Route path="/login" element={<Login />} />

              {/* Protected Admin Routes */}
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="/case-studies/:slug" element={<ProjectDetails />} />
              <Route
                path="/admin/blogs"
                element={
                  <ProtectedRoute>
                    <BlogList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/blogs/new"
                element={
                  <ProtectedRoute>
                    <BlogForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/blogs/edit/:id"
                element={
                  <ProtectedRoute>
                    <BlogForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/case-studies"
                element={
                  <ProtectedRoute>
                    <CaseStudies />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/case-studies/new"
                element={
                  <ProtectedRoute>
                    <CaseStudyForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/case-studies/edit/:id"
                element={
                  <ProtectedRoute>
                    <CaseStudyForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/contact-messages"
                element={
                  <ProtectedRoute>
                    <ContactMessages />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </ContentAvailabilityProvider>
        </AuthProvider>
      </ToastProvider>
    </LanguageProvider>
  );
}
